import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdvanceRecieptComponent } from './advance-reciept/advance-reciept.component';
import { BillingComponent } from './billing.component';
import { BillRecoveryManagerComponent } from './bill-recovery-manager/bill-recovery-manager.component';


const routes: Routes = [
   {path:'',component:BillingComponent},
   {path:'AdvanceReceipt',component:AdvanceRecieptComponent},
   {path:'RecoveryManager',component:BillRecoveryManagerComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BillingRoutingModule { }
